import React, { useEffect, useLayoutEffect, useRef, useState } from "react";

const ImageWithRect = ({ data, show }) => {
  const divRef = useRef(null);
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const [BoxData, setBoxData] = useState({
    x: 0,
    y: 0,
    height: 0,
    width: 0,
  });

  useLayoutEffect(() => {
    if (divRef.current) {
      setWidth(divRef?.current?.offsetWidth);
      setHeight(divRef?.current?.offsetHeight);
      getBoxData(divRef?.current?.offsetWidth, divRef?.current?.offsetHeight);
    }
  }, []);

  useEffect(() => {
    if (divRef.current) {
      setTimeout(() => {
        setWidth(divRef?.current?.offsetWidth);
        setHeight(divRef?.current?.offsetHeight);
        getBoxData(divRef?.current?.offsetWidth, divRef?.current?.offsetHeight);
      }, 100);
    }
  }, [show]);

  function getBoxData(width, height) {
    const x_scale = width / data?.Width;
    const y_scale = height / data?.Height;
    const BoxCod = data?.bounding_box;

    let x1 = BoxCod && BoxCod[0] ? BoxCod[0] : 0;
    let x2 = BoxCod && BoxCod[2] ? BoxCod[2] : 0;
    let y1 = BoxCod && BoxCod[1] ? BoxCod[1] : 0;
    let y2 = BoxCod && BoxCod[3] ? BoxCod[3] : 0;

    const x = x1 * x_scale;
    const y = y1 * y_scale;
    const Boxwidth = x2 * x_scale - x1 * x_scale;
    const Boxheight = y2 * y_scale - y1 * y_scale;

    setBoxData({
      x: x,
      y: y,
      width: Boxwidth,
      height: Boxheight,
    });
  }

  useEffect(() => {
    if (divRef.current) {
      setTimeout(() => {
        getBoxData(divRef.current?.offsetWidth, divRef.current?.offsetHeight);
      }, 100);
    }
  }, [width, height, data, show]);

  return (
    <div className="w-full h-full pt-2 relative" ref={divRef}>
      <img
        className="w-full h-full object-fill rounded-lg"
        src={data?.img}
        alt="Captured"
      />
      {BoxData.width > 0 && BoxData.height > 0 && (
        <div
          className="border-[3px] border-[#FF6161] z-40 transition-opacity duration-100"
          style={{
            position: "absolute",
            top: BoxData.y,
            left: BoxData.x,
            width: BoxData.width,
            height: BoxData.height,
          }}
        >
          <div className="bg-[#FF6161] text-white w-fit px-2 font-bold text-[16px] mt-[-25px] ml-[-2.6px]">
            {data?.label || ""}
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageWithRect;
